// extracted by mini-css-extract-plugin
export default {"wrapper":"Categories-module__wrapper___CZi0C"};